// Shee (and staged post captions) use **bold** markdown. Render it as real bold on screen and let
// Copy actions strip it to plain text so pasting elsewhere never carries markdown asterisks or the
// container's background color as a highlight (a common artifact when copying from a styled <div>).
export const stripMd = (text) => (text || "").replace(/\*\*([^*]+)\*\*/g, "$1");

export const renderRich = (text) =>
  (text || "").split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**")
      ? <strong key={i}>{part.slice(2, -2)}</strong>
      : <span key={i}>{part}</span>
  );

// Same as renderRich, but also colors #hashtags — used inside the authentic platform mockups
// where hashtags visually need to read as native platform links, not plain text.
export const renderSocial = (text, hashtagColor = "#00376B") =>
  (text || "").split(/(\*\*[^*]+\*\*|#[\p{L}\p{N}_]+)/gu).map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("#")) return <span key={i} style={{ color: hashtagColor }}>{part}</span>;
    return <span key={i}>{part}</span>;
  });
